import { useMutation, useQueryClient } from '@tanstack/react-query';

import { IMPORT_STATE } from '@/entities/(integration)/integrations';

import type { YotpoInfo } from '../model';
import { deleteYotpoInfo } from './delete-yotpo-info';
import { importYotpoFeedback } from './import-yotpo-feedback';
import { yotpoQueryKeys } from './yotpo.queries';

/**
 * Yotpo 연동 해제 mutation
 */
export const useDeleteYotpoMutation = (workspaceAlias: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ alias }: { alias: string }) =>
      deleteYotpoInfo({ yotpo_id: alias }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: yotpoQueryKeys.all(workspaceAlias),
      });
    },
  });
};

/**
 * Yotpo 피드백 가져오기 mutation (optimistic update 포함)
 */
export const useImportYotpoFeedbackMutation = (workspaceAlias: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      alias,
      dateRange,
    }: {
      alias: string;
      dateRange: NullableDateRangeT;
    }) =>
      importYotpoFeedback({
        yotpo_id: alias,
        start_date: dateRange.start_date || '',
        end_date: dateRange.end_date || '',
      }),
    onSuccess: (_, variables) => {
      // 배열에서 특정 항목만 optimistic update
      queryClient.setQueryData(
        yotpoQueryKeys.all(workspaceAlias),
        (old: YotpoInfo[] | undefined) => {
          if (!old) return old;
          return old.map((w) =>
            w.alias === variables.alias
              ? {
                  ...w,
                  state: IMPORT_STATE.IMPORTING,
                  import_state: IMPORT_STATE.IMPORTING,
                }
              : w,
          );
        },
      );
    },
  });
};
